import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import './ProgressButton.css';

const ProgressButton = ({
  isLoading,
  onClick,
  loadingLabel,
  label,
  className,
  disabled = false,
  expectedDuration = 25000
}) => {
  const [progress, setProgress] = useState(0);
  const maxPercentBeforeFinish = 80;

  useEffect(() => {
    let interval;
    let timer;

    if (isLoading) {
      setProgress(0);
      const startTime = Date.now();

      interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const percent = Math.min((elapsed / expectedDuration) * 100, maxPercentBeforeFinish);
        setProgress(percent);
      }, 100);
    } else if (progress > 0 && progress < 100) {
      setProgress(100);
      timer = setTimeout(() => {
        setProgress(0);
      }, 500);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [isLoading]);

  return (
    <button id='printButton' className={`min-w-150 ${className} position-relative ${isLoading ? 'cursor-loading' : ''} ${disabled ? 'disabled' : ''}`} onClick={onClick}>
      {progress > 0 && progress <= 100 &&
        <div className="progress-overlay" style={{ width: `${progress}%` }}></div>
      }
      {isLoading ? (
        <>
          {loadingLabel}&nbsp;
          <FontAwesomeIcon icon={faSpinner} spin />
        </>
      ) : (
        label
      )}
    </button>
  );
};

ProgressButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  loadingLabel: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  expectedDuration: PropTypes.number
};

export default ProgressButton;
